<template>
  <div class="d-flex align-items-center bg-eclipse">
    <nav id="primary-nav" class="navbar navbar-expand-lg navbar-dark width-100">
      <div class="container-fluid">
        <router-link class="navbar-brand font-vogue" to="/">Lake Jackson Post</router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" to="/guides">Guides</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/events">Events</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/weather">Weather</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/about">About</router-link>
            </li>
          </ul>         
        </div>
      </div>
    </nav>
  </div>  
  <router-view/>
</template>

<style src="./css/main.css"></style>

<style>

</style>
